/* Simple, tree-shakeable logger with runtime toggle */

type Level = 'debug' | 'info' | 'warn' | 'error' | 'silent';

const getLevel = (): Level => {
  // Prefer explicit runtime flag if present
  try {
    if (typeof window !== 'undefined' && (window as any).__LOG_LEVEL__) {
      return (window as any).__LOG_LEVEL__ as Level;
    }
  } catch (_e) {}
  // Default to 'info' in production-like situations
  return 'info';
};

let level: Level = getLevel();

export const setLogLevel = (next: Level) => {
  level = next;
};

const should = (l: Level) => {
  const order: Record<Level, number> = { debug: 10, info: 20, warn: 30, error: 40, silent: 100 };
  return order[l] >= order[level];
};

export const logDebug = (...args: any[]) => {
  if (should('debug')) console.log(...args);
};
export const logInfo = (...args: any[]) => {
  if (should('info')) console.info(...args);
};
export const logWarn = (...args: any[]) => {
  if (should('warn')) console.warn(...args);
};
export const logError = (...args: any[]) => {
  if (should('error')) console.error(...args);
};

